(() => {

	async function addFreeGift(giftVariantId) {
		try {
			const response = await fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					updates: {
						[giftVariantId]: 1
					}
				})
			});

			if (!response.ok) {
				throw new Error(`HTTP-Fehler: ${response.status}`);
			}

			const updatedCart = await response.json();
			// console.log('Warenkorb aktualisiert:', updatedCart);
			return updatedCart;
		} catch (error) {
			// console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
			throw error;
		}
	}

	async function removeFreeGift(giftVariantId) {
		try {
			// console.log("####### removeFreeGift #######")
			const response = await fetch('/cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					updates: {
						[giftVariantId]: 0
					}
				})
			});

			if (!response.ok) {
				throw new Error(`HTTP-Fehler: ${response.status}`);
			}

			const updatedCart = await response.json();
			// console.log('Warenkorb aktualisiert:', updatedCart);
			return updatedCart;
		} catch (error) {
			// console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
			throw error;
		}
	}

	const handleFreeGift = () => {
		const shippingBar = document.querySelector('free-shipping-bar');
		const giftThreshold = parseInt(shippingBar.dataset.giftThreshold);

		// Get fresh cart data
		fetch('/cart.js').then(response => response.json()).then(cart => {
			if (!shippingBar) return;

			const totalPrice = cart.items_subtotal_price;
			let giftIsInCart = false;

			cart.items.forEach(item => {
				if (item.variant_id == 47338237952325) {
					giftIsInCart = true;
				}
			});

			if (totalPrice >= giftThreshold && !giftIsInCart) {
				addFreeGift('47338237952325').then(cart => {
					setTimeout(() => {
						document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
							bubbles: true,
							detail: {
								cart: {
									"item_count": cart.item_count
								},
							},
						}));
					}, 500);
				});
			} else if (totalPrice < giftThreshold) {
				removeFreeGift('47338237952325').then(cart => {
					setTimeout(() => {
						document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
							bubbles: true,
							detail: {
								cart: {
									"item_count": cart.item_count
								},
							},
						}));
					}, 500);
				});
			}
		})
	}

	document.addEventListener('cart:updated', () => {
		handleFreeGift();
	});

	document.addEventListener('DOMContentLoaded', () => {
		handleFreeGift();
	});
})();
